/* Newsletter signup glue — attaches Klaviyo's legacy subscribe handler to
 * every newsletter form on the page, replacing live's inline per-section
 * script. Options are live's, verbatim; the success callback reproduces
 * live's effects (hide the field row, settle the form height) in vanilla
 * DOM — live wrote it in jQuery, which only works because
 * klaviyo_subscribe.js injects jQuery 1.10.2 when the page has none. New
 * first-party code does not lean on that side effect.
 *
 * Enhancement only: the form is a plain GET to manage.kmail-lists.com and
 * submits without JS (new tab), exactly like live's.
 *
 * Klar signup attribution: the legacy embed never dispatches the
 * `klaviyoForms` window event that layout/theme.liquid listens for (that
 * event belongs to forms built in Klaviyo's form builder), so the `success`
 * option is the only hook these forms offer. It publishes the same
 * `Klar:signupEvent` the layout publishes for builder forms, onto the
 * Shopify analytics bus the Klar Customer Events pixel subscribes to.
 */
(function () {
  function attachAll() {
    if (!window.KlaviyoSubscribe || typeof window.KlaviyoSubscribe.attachToForms !== 'function') return;
    document.querySelectorAll('form[data-newsletter-signup]').forEach(function (form) {
      window.KlaviyoSubscribe.attachToForms('#' + form.id, {
        hide_form_on_success: true,
        custom_success_message: true,
        extra_properties: {
          $source: '$embed',
          $method_type: 'Klaviyo Form',
          $method_id: 'embed',
          $consent_version: 'Embed default text',
        },
        success: function () {
          // Runs before klaviyo_subscribe.js resets the form, so the field
          // still holds the submitted address. Nothing to attribute without one.
          var email = ((form.elements.email && form.elements.email.value) || '').trim();
          if (
            email &&
            window.Shopify &&
            window.Shopify.analytics &&
            typeof window.Shopify.analytics.publish === 'function'
          ) {
            window.Shopify.analytics.publish('Klar:signupEvent', { email: email });
          }
          document.querySelectorAll('.klaviyo-legacy-form .newsletter-fields-container').forEach(function (fields) {
            fields.style.display = 'none';
          });
          document.querySelectorAll('.klaviyo-legacy-form').forEach(function (legacyForm) {
            legacyForm.style.height = 'auto';
          });
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll, { once: true });
  } else {
    attachAll();
  }
})();
